import React, { createContext, useContext, useEffect, ReactNode } from 'react';
import { observer } from 'mobx-react';
import authStore from '../store/Auth';
import { UserMeResponse } from '../api/auth';

interface AuthContextValues {
  user: UserMeResponse | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  isInitialized: boolean;
  login: (credentials: { login: string; password: string }) => Promise<void>;
  register: (data: {
    email: string;
    first_name: string;
    last_name: string;
    company_name: string;
    password: string;
  }) => Promise<void>;
  logout: () => Promise<void>;
  updateUser: () => Promise<void>;
}

const AuthContext = createContext<AuthContextValues | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = observer(
  ({ children }) => {
    useEffect(() => {
      // Инициализация авторизации при загрузке только один раз
      if (!authStore.isInitialized) {
        authStore.init().catch((error) => {
          console.error('Auth initialization failed:', error);
        });
      }
    }, []); // Пустой массив зависимостей - выполняется только один раз

    const contextValue: AuthContextValues = {
      user: authStore.user,
      isAuthenticated: authStore.isAuthenticated,
      isLoading: authStore.isLoading,
      isInitialized: authStore.isInitialized,
      login: authStore.login,
      register: authStore.register,
      logout: authStore.logout,
      updateUser: authStore.getMe,
    };

    return (
      <AuthContext.Provider value={contextValue}>
        {children}
      </AuthContext.Provider>
    );
  },
);

export default AuthProvider;
